/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./createVodGate.defs.js";
export { main as default } from "./createVodGate.defs.js";
